import { Controller } from '@hotwired/stimulus'
import TomSelect from 'tom-select'

// Connects to data-controller="tom-select"
export default class extends Controller {
  connect() {
    const config = {
      allowEmptyOption: false,
      plugins: [
        'dropdown_input',
        'clear_button',
        'input_autogrow',
        'remove_button'
      ],
      render: {
        no_results: function (data, escape) {
          return (
            '<div class="no-results">検索結果が見つかりませんでした: "' +
            escape(data.input) +
            '"</div>'
          )
        }
      }
    }
    this.tomselect = new TomSelect(this.element, config)
  }
  disconnect() {
    this.tomselect.destroy()
  }
}
